import { Stack, Text } from '@mantine/core';
import type { SubmissionSupportConfig } from '../types/schema';

interface ProgramSupportInfoProps {
  support?: SubmissionSupportConfig;
}

export default function ProgramSupportInfo({ support }: ProgramSupportInfoProps) {
  if (!support || (!support.name && !support.phone && !support.email && !support.details?.length)) {
    return null;
  }

  return (
    <Stack gap={2} align="center">
      <Text size="sm" c="dimmed" ta="center">
        {support.intro ?? 'For assistance, contact:'}
      </Text>
      {support.name && <Text size="sm" c="dimmed" fw={600} ta="center">{support.name}</Text>}
      {support.phone && <Text size="sm" c="dimmed" ta="center">Phone: {support.phone}</Text>}
      {support.email && <Text size="sm" c="dimmed" ta="center">Email: {support.email}</Text>}
      {support.details?.map((detail) => (
        <Text key={detail} size="sm" c="dimmed" ta="center">{detail}</Text>
      ))}
    </Stack>
  );
}